// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { addMinutes as fn } from "../addMinutes.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const addMinutesWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default addMinutesWithOptions;
